// extracted by mini-css-extract-plugin
export default {"bundleBadge":"BundleBadge_bundleBadge__Rwxxl","list":"BundleBadge_list__qO6Qh"};